import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon } from 'react-native-elements';
import BottomInfo from '../BottomInfo';
import './footer.css';

const Footer: React.FC = () => {
  return (
    <footer>
      <BottomInfo />
      <div className="footer-flex">
        <View style={styles.icons}>
          <a target="_blank" href="https://www.facebook.com/zonetailmobile/">
            <Icon
              name="facebook-f"
              size={15}
              reverse
              type="font-awesome"
              tvParallaxProperties={null}
            />
          </a>
          <a
            target="_blank"
            href="https://twitter.com/Zonetail?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
          >
            <Icon
              name="twitter"
              size={15}
              reverse
              type="font-awesome"
              tvParallaxProperties={null}
            />
          </a>
          <a target="_blank" href="https://www.linkedin.com/company/zonetail">
            <Icon
              name="linkedin"
              size={15}
              reverse
              type="font-awesome"
              tvParallaxProperties={null}
            />
          </a>
          <a target="_blank" href="https://www.instagram.com/zonetail/">
            <Icon
              name="instagram"
              size={15}
              reverse
              type="font-awesome"
              tvParallaxProperties={null}
            />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCD4hBFWhYphAOULMgfHPxXw?view_as=subscriber"
          >
            <Icon
              name="youtube"
              size={15}
              reverse
              type="font-awesome"
              tvParallaxProperties={null}
            />
          </a>
        </View>
      </div>
      <div className="copyright">
        &copy; 2021 Zonetail Inc. All rights reserved
      </div>
    </footer>
  );
};

const styles = StyleSheet.create({
  cards: {
    display: 'flex',
    flexDirection: 'row',
    margin: 'auto',
    maxWidth: 1200,
    padding: 36,
  },
  title: {
    textAlign: 'left',
    color: '#303133',
  },
  icons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

export default Footer;
